import { render } from "./ColorField.vue?vue&type=template&id=8427480c"
import script from "./ColorField.vue?vue&type=script&lang=js"
export * from "./ColorField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ColorField.vue"]])

export default __exports__